<template>
    <FormControl
        :label="customField.title"
        :required="customField.isRequired"
        :error="errors.getValidationErrorUsingRawString(customField.id.value)"
    >
        <template
            v-if="
                typeof savedValue.response === 'string' ||
                savedValue.response === null
            "
        >
            <input
                type="hidden"
                :name="`${RequestBodyKeyEnum.ScheduleMeeting_CustomFieldResponses}[${customField.id.value}][${RAW_RESPONSE_CUSTOM_FIELD_ID_KEY}]`"
                :value="customField.id.value"
            />
            <template
                v-if="
                    localSettings.data.textType ===
                    CustomFieldTextTypeEnum.SingleLine
                "
            >
                <TextInput
                    :useBookingFormThemeCssVariables="true"
                    :required="customField.isRequired"
                    :name="`${RequestBodyKeyEnum.ScheduleMeeting_CustomFieldResponses}[${customField.id.value}][${RAW_RESPONSE_CONTENT_KEY}]`"
                    :placeholder="localSettings.data.textPlaceholderText"
                    :modelValue="savedValue.response ?? undefined"
                />
            </template>
            <template
                v-else-if="
                    localSettings.data.textType ===
                    CustomFieldTextTypeEnum.MultiLine
                "
            >
                <TextareaInput
                    :useBookingFormThemeCssVariables="true"
                    :required="customField.isRequired"
                    rows="3"
                    :name="`${RequestBodyKeyEnum.ScheduleMeeting_CustomFieldResponses}[${customField.id.value}][${RAW_RESPONSE_CONTENT_KEY}]`"
                    :placeholder="localSettings.data.textPlaceholderText"
                    :modelValue="savedValue.response ?? undefined"
                />
            </template>
        </template>
        <template v-else>
            <UnexpectedError />
        </template>
    </FormControl>
</template>

<script setup lang="ts">
    import { type PropType } from 'vue'
    import CustomField from '@/App/CustomField/Entity/CustomField'
    import TextInput from '@/Shared/Component/Forms/TextInput.vue'
    import FormControl from '@/Shared/Component/Forms/FormControl.vue'
    import TextareaInput from '@/Shared/Component/Forms/TextareaInput.vue'
    import {
        CustomFieldTextTypeEnum,
        RAW_RESPONSE_CONTENT_KEY,
        RAW_RESPONSE_CUSTOM_FIELD_ID_KEY,
        type CustomFieldResponseDTO,
        type CustomFieldSettingsTextType,
    } from '@/Shared/AutoGenerated/Main'
    import UnexpectedError from '@/BookingForm/BookingForm/Component/CustomField/UnexpectedError.vue'
    import { RequestBodyKeyEnum } from '@/Shared/AutoGenerated/RequestFieldEnum'

    const props = defineProps({
        customField: {
            type: Object as PropType<CustomField>,
            required: true,
        },
        errors: {
            type: Object,
            required: true,
        },
        savedValue: {
            type: Object as PropType<CustomFieldResponseDTO>,
            required: true,
        },
    })

    const localSettings: CustomFieldSettingsTextType =
        props.customField.settings
</script>
